import { faqItems } from '@/mocks/home';

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 font-heading">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-500 mt-2">
            关于菲菲影院的常见疑问解答
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6"
            >
              <h3 className="text-base md:text-lg font-bold text-foreground-900 font-heading mb-2">
                {item.question}
              </h3>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                {item.answer}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}